require('./stream-listen-template.html');
var generateUUID = require('../../common/uuid');

angular.module('bbl.module.streamListen', [])
  .config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/listen/:token?', {
      templateUrl: 'stream-listen-template.html',
      controller: 'streamListenController',
      joinCallRoute: true,
      invitedLayout: true,
      particularBrand: true
    });
  }])
  .controller('streamListenController', [
    '$scope', '$routeParams', '$http', 'PusherUpdates', '$timeout', '$cookies',
    streamListenController
  ]);

function streamListenController($scope, $params, $http, PusherUpdates, $timeout, $cookies) {
  var userid = $cookies.get('live-stream-uuid') || generateUUID();
  $cookies.put('live-stream-uuid', userid);

  $scope.state = {
    loading: false,
    streamReady: false,
    playing: false,
    mp3File: null,
    started: null,
  };

  $scope.JOIN = {};

  var prom;
  var player = new Audio();

  var trackListeningUser = function trackListeningUserFn() {
    var ping = function ping() {
      var date = new Date();
      $http.get('/bridges/ping/'+$params.token + '?' + [
        date.setMilliseconds(0),
        $scope.JOIN.bridge,
        userid,
      ].join('&')).then(angular.noop, angular.noop);
    };

    setInterval(ping, 10 * 1000);
    ping();
    trackListeningUser = angular.noop;
  };

  function getFile() {
    return $http.get('/bridges/get_playback_file_special/'+$scope.JOIN.bridge)
      .then(function(response) {
        $scope.state.mp3File = response.data;
      });
  }

  function ft(str) {
    return str.replace(' ', 'T');
  }

  function checkStreamStatus() {
    return $http.get('/bridges/get_play_start_timestamp/'+$scope.JOIN.bridge).then(function(response) {
      var started = +new Date(ft(response.data.playback_start_timestamp));
      var currentTime = +new Date(ft(response.data.current_timestamp));

      $scope.state.started = Date.now() - (currentTime - started);
      $scope.state.streamReady = Boolean(started);

      prom = null;
      if (!started) {
        return Promise.reject('not started');
      }

      return getFile();
    });
  }

  var bindEvents = function() {
    $scope.$root.$on('pusher:call_play:play_started', $scope.play);

    $scope.$root.$on('pusher:call_play:play_stopped', function() {
      player.pause();
      player.src = '';
      $scope.state.streamReady = false;
      $scope.state.mp3File = null;
      $scope.state.playing = false;
      $scope.state.loading = true;
      $timeout(angular.noop);
    });

    bindEvents = angular.noop;
  };

  $scope.play = function() {
    if (!$scope.JOIN.bridge) {
      return;
    }

    bindEvents();
    trackListeningUser();
    if (!$scope.state.streamReady) {
      $scope.state.loading = true;
      (prom || (prom = checkStreamStatus())).then($scope.play, angular.noop);
      return;
    }

    player.src = $scope.state.mp3File;

    player.play().then(function() {
      player.currentTime = (Date.now() - $scope.state.started) / 1000 - 1;
      $scope.state.loading = false;
      $scope.state.playing = true;
      $scope.$apply();
    });
  };

  player.addEventListener('pause', function() {
    if (player.currentTime >= player.duration) {
      $scope.state.playing = false;
      $scope.state.streamReady = false;
      $scope.state.loading = true;
      $scope.$apply();
    }
  });

  player.addEventListener('play', function() {
    if (!('mediaSession' in navigator)) {
      return;
    }

    navigator.mediaSession.metadata = new MediaMetadata({
      title: $scope.JOIN.brand_tagline,
      artist: $scope.JOIN.company,
    });

    navigator.mediaSession.setActionHandler('play', function() { /* Code excerpted. */ });
    navigator.mediaSession.setActionHandler('pause', function() { /* Code excerpted. */ });
    navigator.mediaSession.setActionHandler('stop', function() { /* Code excerpted. */ });
  });

  function getTokenData(token) {
    return $http.get('/bridges/api/v1/get-token-data/' + token + '/?format=json')
    .then(function(response) {
      var data = response.data, call = data.call;

      return {
        bridge: call.bridgeId,
        company: call.company_name,
        bridge_number: call.number,
        friendly_number: call.friendly_number,
        date: call.date,
        plivo_username: call.plivo_username,
        plivo_password: call.plivo_password,
        brand_logo: (call.brand_logo || 'assets/images/logo@2x.png'),
        brand_tagline: call.bridge_title || call.bridge_description || call.brand_tagline,
        service_provider: call.service_provider,
        jfb_url: call.jfb_url,
      };
    });
  }

  function setTokenData(callData) {
    sessionStorage.setItem('[bblapp.io][token-data]', JSON.stringify(callData));
    $scope.$root.particularBrandLogo = callData.brand_logo;
    $scope.$root.particularBrandTagline = callData.brand_tagline;

    $scope.JOIN = angular.copy(callData);
    $scope.confReady = true;

    prom = checkStreamStatus();

    PusherUpdates.initConnection();
    PusherUpdates.subscribeToChannel($scope.JOIN.bridge, 'call_play');
  }

  var sessionData = JSON.parse(sessionStorage.getItem('[bblapp.io][token-data]'));

  if (sessionData) {
    setTokenData(sessionData);
  }

  getTokenData($params.token).then(setTokenData);
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/stream-listen/stream-listen.module.js
 ** module id = 413
 ** module chunks = 0
 **/